<template>
  <settings-modal
    :locked="isLoading"
    class="t-route-channel-remove-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Are you sure you want to remove this channel route?</span>
    <error-alert
      :error="error"
    />
    <div class="subheading">{{ channelRoute.currency }} / {{ channelRoute.channel | optionName(Payment.channelOptions) }}</div>
    <template slot="actions">
      <v-btn
        class="t-remove-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onRemoveButtonClick"
      >Remove</v-btn>
      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal'
  import modal from '@/mixins/modal'
  import form from '@/mixins/form'
  import { mapActions, mapGetters } from 'vuex'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import flashMessages from '@/mixins/flashMessages'
  import ChannelRoutesApi from '@/services/Api/ChannelRoutesApi'
  import Payment from '@/models/Payment'

  export default {
    name: 'ChannelRouteRemoveModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [modal, form, flashMessages],
    data () {
      return {
        Payment,
        error: null,
        isLoading: false,
        deleteChannelRouteApiRequest: new ApiRequest(ChannelRoutesApi.delete)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      channelRoute () {
        return this.modal.data.channelRoute
      },
      successCallback () {
        return this.modal.data.successCallback
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onRemoveButtonClick () {
        this.setError(null)
        this.setIsLoading(true)

        this.deleteChannelRouteApiRequest.execute(this.channelRoute.id)
          .then(() => {
            this.successCallback()
            this.showSuccessFlashMessage('Channel route successfully deleted!')
          })
          .catch((error) => this.setError(error))
          .finally(() => this.setIsLoading(false))
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
